import React from 'react';

const trustPillars = [
  {
    id: 'privacy',
    title: 'Privacy-First',
    description: 'Your scans stay on your device. We never track what you eat or sell your data to advertisers.',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
  },
  {
    id: 'adfree',
    title: 'Ad-Free Forever',
    description: 'No annoying ads, ever. We believe health tools should be free from advertising influence.',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
      </svg>
    ),
  },
  {
    id: 'transparent',
    title: 'Open About Ingredients',
    description: 'We explain why ingredients are flagged with links to research. Make your own informed decisions.',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
];

function TrustSection() {
  return (
    <section className="bg-gradient-sage text-white py-16 md:py-20 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-10 left-20 w-32 h-32 bg-white/5 rounded-full blur-2xl" />
        <div className="absolute bottom-20 right-20 w-48 h-48 bg-white/5 rounded-full blur-3xl" />
      </div>

      <div className="section relative z-10">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-white mb-4">
            Built for Peace of Mind
          </h2>
          <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto">
            We built FoodLens because we use it ourselves. Here's what we promise.
          </p>
        </div>

        {/* Trust Pillars */}
        <div className="grid md:grid-cols-3 gap-8">
          {trustPillars.map((pillar, index) => (
            <div
              key={pillar.id}
              className="text-center p-8 rounded-3xl bg-white/10 backdrop-blur-sm border border-white/20 animate-fade-in-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Icon */}
              <div className="inline-flex p-4 rounded-2xl bg-white/20 mb-6">
                {pillar.icon}
              </div>

              {/* Title */}
              <h3 className="font-display text-2xl text-white mb-3">{pillar.title}</h3>

              {/* Description */}
              <p className="text-white/80 leading-relaxed">{pillar.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <a
            href="/privacy"
            className="inline-flex items-center gap-2 text-white/90 hover:text-white underline underline-offset-4 transition-colors"
          >
            Read our full privacy policy
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}

export default TrustSection;
